import { CATALOG, CORE, DETAILED, FLEX, NEEDS } from './catalog';
import { buildPeriods, dueFor, periodMid, periodOf } from './schedule';
import { Ceremony, DraftTask, Level, Status } from './types';

interface Answers {
  months: number; // mois restants avant le mariage
  level: Level;
  ceremonies: Ceremony[];
  statuses: Record<string, Status>;
  hasGuests: boolean; // liste d'invités déjà commencée dans l'app
}

// Tâches proposées d'après les réponses de l'onboarding. Aucune période ne reste
// vide : on y place la tâche la plus utile de ce moment-là (même hors du niveau
// choisi), sinon une tâche « à tout moment ». Sans invités dans l'app, la liste
// d'invités ouvre le planning (elle conditionne lieu, budget et faire-part).
export function buildPlan({ months, level, ceremonies, statuses, hasGuests }: Answers): DraftTask[] {
  const periods = buildPeriods(months);
  const inLevel = (key: string) =>
    level === 'overview' ? CORE.includes(key) : level === 'balanced' ? !DETAILED.includes(key) : true;
  const all: DraftTask[] = CATALOG.filter(
    (c) =>
      (!c.cond || ceremonies.includes(c.cond)) &&
      !(c.key === 'invites' && hasGuests) &&
      !(c.status && (statuses[c.status] ?? 'todo') !== 'todo') &&
      !(NEEDS[c.key] && statuses[NEEDS[c.key]] === 'skip'),
  ).map((c) => ({ key: c.key, label: c.label, tag: c.tag, due: dueFor(months, c.pos, c.earliest, c.latest) }));

  const tasks = all.filter((task) => inLevel(task.key));
  const flex = [...FLEX];
  for (const p of periods) {
    if (tasks.some((task) => periodOf(periods, task.due) === p)) continue;
    const hidden = all.find((task) => !tasks.includes(task) && periodOf(periods, task.due) === p);
    if (hidden) {
      tasks.push(hidden);
      continue;
    }
    const f = flex.shift();
    if (f) tasks.push({ key: f[0], label: f[1], tag: f[2], due: periodMid(p) });
  }
  return tasks.sort((a, b) => b.due - a.due);
}
